import { apiClient } from '@/config/api';

export type LogementsOverviewRow = {
  areaId: number;
  name: string;
  avgTemp: number | null;
  minTemp: number | null;
  maxTemp: number | null;
  amplitude: number | null;
  comfortPct: number | null; // 0..1
  comfortScore: number | null; // 0..100
};

export type LogementsOverviewResponse = {
  range: { from: string; to: string };
  comfort: { min: number; max: number };
  summary: {
    logementsCount: number;
    avgTemperatureGlobal: number | null;
    outOfComfortPct: number | null;
    maxAvgGapBetweenLogements: number | null;
    logementsWithIssueCount: number;
  };
  top: {
    hot: Array<{ areaId: number; name: string; avgTemp: number }>;
    cold: Array<{ areaId: number; name: string; avgTemp: number }>;
    unstable: Array<{ areaId: number; name: string; amplitude: number }>;
  };
  rows: LogementsOverviewRow[];
};

export type GetOverviewParams = {
  projectId: number;
  from?: string;
  to?: string;
  comfortMin?: number;
  comfortMax?: number;
};

export const logementsOverviewService = {
  async getOverview(params: GetOverviewParams): Promise<LogementsOverviewResponse> {
    const response = await apiClient.get<LogementsOverviewResponse>('/logements/overview', { params });
    return response.data;
  },
};

